module.exports = __webpack_public_path__ + "img/顶部背景.9fbb92f9.png";